import { useEffect, useState } from "react";
import { auth, provider } from "../firebase/config";
import { signInWithPopup, onAuthStateChanged } from "firebase/auth";

import AthleteForm from "../components/admin/athletes/AthleteForm";
import AthleteTable from "../components/admin/athletes/AthleteTable";
import EntryForm from "../components/admin/entries/EntryForm";
import EntryTable from "../components/admin/entries/EntryTable";
import LeagueForm from "../components/admin/leagues/LeagueForm";
import LeagueTable from "../components/admin/leagues/LeagueTable";

import "../styles/admin.css";

const ADMIN_EMAIL = "christianbcutter@yahoo.com";

export default function Admin() {
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    onAuthStateChanged(auth, (currentUser) => setUser(currentUser));
  }, []);

  const handleLogin = () => {
    signInWithPopup(auth, provider);
  };

  if (!user)
    return (
      <main className="admin-container">
        <button className="admin-login-button" onClick={handleLogin}>
          Sign in with Google
        </button>
      </main>
    );

  if (user.email !== ADMIN_EMAIL)
    return (
      <main className="admin-container">
        <p className="admin-access-denied">Access Denied</p>
      </main>
    );

  return (
    <main className="admin-container">
      <h1 className="admin-header">Admin Dashboard</h1>

      <section className="admin-section">
        <h2 className="admin-section-title">Leagues</h2>
        <div className="admin-section-content">
          <LeagueForm />
          <LeagueTable />
        </div>
      </section>

      <section className="admin-section">
        <h2 className="admin-section-title">Athletes</h2>
        <div className="admin-section-content">
          <AthleteForm />
          <AthleteTable />
        </div>
      </section>

      <section className="admin-section">
        <h2 className="admin-section-title">Entries</h2>
        <div className="admin-section-content">
          <EntryForm />
          <EntryTable />
        </div>
      </section>

      <button className="admin-login-button" onClick={() => auth.signOut()}>
        Sign Out
      </button>
    </main>
  );
}
